var render = function render(_c,_vm){return _c('div',{staticClass:"row base-attribute-display"},[_c('div',{staticClass:"col-md-5 col-lg-4 col-xl-3 base-attribute-label text-left text-md-right"},[_vm._v(" "+_vm._s(_vm.props.label)+" ")]),_c('div',{staticClass:"col-md-7 col-lg-8 col-xl-9 base-attribute-value"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.props.value)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }